import { render, staticRenderFns } from "./CTextString.vue?vue&type=template&id=14865de1"
import script from "./CTextString.vue?vue&type=script&lang=js"
export * from "./CTextString.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14865de1')) {
      api.createRecord('14865de1', component.options)
    } else {
      api.reload('14865de1', component.options)
    }
    module.hot.accept("./CTextString.vue?vue&type=template&id=14865de1", function () {
      api.rerender('14865de1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CTextString.vue"
export default component.exports